/** @format */

import {
	HmfActionTextComponent,
	HmfSidePanelComponent,
	HmfSkeletonComponent
} from '@dsg-tech/homefield-angular';

import { CommonModule } from '@angular/common';
import { FeedbackModule } from '../feedback/feedback.module';
import { NgModule } from '@angular/core';
import { SizeChartComponent } from './size-chart.component';

@NgModule({
	declarations: [SizeChartComponent],
	imports: [
		CommonModule,
		FeedbackModule,
		HmfActionTextComponent,
		HmfSidePanelComponent,
		HmfSkeletonComponent
	],
	exports: [SizeChartComponent]
})
export class SizeChartModule {}
